export const saveOnStorage = (key: string, value: unknown): void =>
  window.localStorage.setItem(key, JSON.stringify(value));

export const getFromStorage = (key: string): unknown | null => {
  const storedValue = window.localStorage.getItem(key);

  return storedValue ? JSON.parse(storedValue) : null;
};
